export type ApiErrorCode =
  | 'UNAUTHORIZED'
  | 'FORBIDDEN'
  | 'CONFLICT'
  | 'NOT_FOUND'
  | 'VALIDATION'
  | 'RATE_LIMITED'
  | 'LOCKED'
  | 'UNKNOWN';

export interface FieldError {
  path: string;
  message: string;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ApiErrorCode,
    message: string,
    public readonly errors?: FieldError[],
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}

export function isUnauthorized(e: unknown): e is ApiError {
  return isApiError(e) && e.status === 401;
}

export function isForbidden(e: unknown): e is ApiError {
  return isApiError(e) && e.status === 403;
}

export function isConflict(e: unknown): e is ApiError {
  return isApiError(e) && e.status === 409;
}

export function isNotFound(e: unknown): e is ApiError {
  return isApiError(e) && e.status === 404;
}

export function isRateLimited(e: unknown): e is ApiError {
  return isApiError(e) && e.status === 429;
}

export function isLocked(e: unknown): e is ApiError {
  return isApiError(e) && e.status === 423;
}
